import { render } from "./preset-preview.vue?vue&type=template&id=48c3003c&lang=pug"
import script from "./preset-preview.vue?vue&type=script&lang=js"
export * from "./preset-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__